// "Explore our range" homepage tabs.
//
// sections/nosh-range.liquid renders two SEPARATE containers: #rangeTabs
// (just the buttons) and #rangePanelGroup (all the panels, in order). That's
// a real, independently-sized two-column layout on desktop — no CSS Grid
// row-sharing tricks needed.
//
// On mobile we want an accordion instead: each panel sitting directly under
// its own button. Rather than fighting one shared markup/CSS structure to
// pull that off, we just physically move the panel elements in the DOM —
// insert each panel right after its button below the breakpoint, and move
// them all back into #rangePanelGroup (in original order) at/above it. Each
// breakpoint ends up with its own simple, real structure.
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const tabsContainer = document.getElementById("rangeTabs");
    const panelGroup = document.getElementById("rangePanelGroup");
    const tabButtons = tabsContainer ? tabsContainer.querySelectorAll(".range-tab") : [];
    const panels = panelGroup ? panelGroup.querySelectorAll(".range-panel") : [];
    if (!tabButtons.length || !panels.length) return;

    const panelByIndex = {};
    panels.forEach(p => { panelByIndex[p.dataset.cat] = p; });

    const mobileQuery = window.matchMedia("(max-width: 860px)");
    let isMobileLayout = null; // force the first layoutFor() call to actually run

    function layoutForMobile() {
      tabButtons.forEach(btn => {
        const panel = panelByIndex[btn.dataset.cat];
        if (panel) btn.insertAdjacentElement("afterend", panel);
      });
    }

    function layoutForDesktop() {
      tabButtons.forEach(btn => {
        const panel = panelByIndex[btn.dataset.cat];
        if (panel) panelGroup.appendChild(panel);
      });
    }

    function applyLayout() {
      const mobile = mobileQuery.matches;
      if (mobile === isMobileLayout) return;
      isMobileLayout = mobile;
      if (mobile) {
        layoutForMobile();
      } else {
        layoutForDesktop();
      }
    }

    tabButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        // Desktop always keeps exactly one panel showing (it's a persistent
        // split view, not a toggle) — only the mobile accordion allows
        // closing the currently-open panel by clicking its own arrow again.
        if (mobileQuery.matches && btn.classList.contains("nosh-active")) {
          tabButtons.forEach(b => b.classList.remove("nosh-active"));
          panels.forEach(p => p.classList.remove("nosh-active"));
          return;
        }
        const index = btn.dataset.cat;
        tabButtons.forEach(b => b.classList.remove("nosh-active"));
        btn.classList.add("nosh-active");
        panels.forEach(p => p.classList.toggle("nosh-active", p.dataset.cat === index));
      });
    });

    applyLayout();
    mobileQuery.addEventListener("change", applyLayout);
  });
})();
